<template>
    <div>
        <button class="btn btn-lg btn-outline-primary mr-2" @click="sendCallback">Отправить коллбек</button>
        <span v-if="isSent" class="p alert" :class="{ 'alert-success': success, 'alert-danger': !success}"  style="font-size: 14px; padding: 6px 8px;" role="alert">
            {{ msg }}
        </span>
        <button class="btn btn-primary" @click="downloadCheck">Скачать чек</button>
        <button v-if="payment.status === 1 && payment.type !== 1" @click="openRefundModal" class="btn btn-danger">Возврат</button>
        <button v-if="payment.status === 0" @click="cancelPayment" class="btn btn-danger">Отмена</button>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: "Transaction",
        data() {
            return {
                payment: JSON.parse(this.paymentProp),
                isSent: '',
                msg: '',
            }
        },
        props: ['paymentProp', 'hash'],
        methods: {
              ...mapActions({
                refundModalToggle: 'refundModalToggle',
                refundModalIdSet: 'refundModalIdSet'
            }),
            sendCallback: function (e) {
                axios.post('/admin/ajax/transaction/' + this.payment.id + '/callback')
                    .then((response) => {
                        this.isSent = true;
                        this.success = response.data.success;
                        this.msg = response.data.message;
                        setTimeout(() => {
                            this.isSent = false;
                        }, 2300);
                    })
                    .catch((error) => {
                        if (error.response != null) {
                            let data = error.response.message;
                        }
                    });
                e.stopPropagation();
            },
            downloadCheck: function () {
                axios({url: '/download-check/' + this.payment.id + '/' + this.hash,
                    method: 'GET',
                    responseType: 'blob'}).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download','check.pdf');
                    document.body.appendChild(link);
                    link.click();
                    })
            },
            cancelPayment: function () {
                if (confirm("Уверены, что хотите отменить?")) {
                    axios.post('/admin/ajax/payment/cancel', {payment_id: this.payment.id})
                        .then(response => {
                            response.data.success ? location.reload() : alert('Возникла ошибка при отмене платежа')
                        })
                        .catch(function () {
                            alert('Возникла ошибка при отмене платежа');
                        })
                }
            },
            refundPayment: function () {
                if (confirm("Хотите оформить возврат?")) {
                    axios.post('/admin/ajax/payment/refund', {payment_id: this.payment.id})
                        .then(response => {
                            response.data.success ? location.reload() : alert('Возникла ошибка при возврате платежа')
                        })
                        .catch(function () {
                            alert('Возникла ошибка при возврате платежа');
                        })
                }
            },
            openRefundModal() {
                this.refundModalIdSet(this.payment.id);
                this.refundModalToggle(true);
            }
        }
    }
</script>
<style scoped>
    button.btn.btn-lg.btn-outline-primary.mr-2 {
        font-size: 14px;
        padding: 4px 8px;
        margin-top: 12px;
    }
    button.btn-primary {
        margin-left: 35px;
        margin-top: 12px;
    }
    button.btn.btn-danger {
        margin-left: 40px;
        margin-top: 12px;
    }
</style>
